import { useState, useEffect, useRef } from 'react'
import { LoginCheck, Log } from "../../Fetch/Login";
import { useNavigate } from "react-router";
import Tabla, { Row, Cell, Head, Body } from "../../Components/Tabla/Tabla";
import ReCAPTCHA from "react-google-recaptcha";
import Logo from "../../logo.svg";
import Loading from "../../Components/Loading/Loading";
import './login.css';
export default function Login() {
    const recaptcha = useRef(null)
    let navigate = useNavigate();
    const [User, setUser] = useState({ show: false, error: '', loading: false, mail: '', pass: '', check: false, captcha: '' })

    useEffect(() => {
        
        if (localStorage.getItem("ContaKMPCot")) {
            
            LoginCheck().then(res => {
                if (res.valid) {
                    localStorage.setItem("ContaKMPCot", res.token);
                    navigate("/FindCotizacion");
                } else {
                    setUser(v => ({
                        ...v,
                        show: true,
                        error: '',
                        mail: '',
                        pass: '',
                        check: false,
                    }));
                    localStorage.removeItem("ContaKMPCot");
                }
            }).catch(e => {
                console.log(e)
            })
        } else {
            setUser(v => ({
                ...v,
                show: true,
                error: '',
                mail: '',
                pass: '',
                check: false
            }));
        }
    }, [navigate, setUser])

    const Iniciar = (e) => {
        e.preventDefault();

        Checking();
        if (User.captcha !== '') {
            Log(User).then(res => {
                if (res.valid === true) {
                    if(res.Login.length>0){
                        localStorage.setItem("ContaKMPCot", res.Login);
                        navigate("/FindCotizacion");
                    }else{
                        recaptcha.current.reset();
                        setUser(v => ({
                        ...v,
                        show: true,
                        error: 'Ingrese el usuario y contraseña correcto',
                        loading: false,
                        check: false
                    }));
                    }
                    
                } else {
                    recaptcha.current.reset();
                    setUser(v => ({
                        ...v,
                        show: true,
                        error: 'Falla en la autentificacion',
                        loading: false,
                        check: false
                    }));
                }
            })
        }
    }

    const Checking = () => {
        if (User.captcha !== '') {
            setUser(v => ({
                ...v,
                loading: true,
                error: ''
            }));
        }else{
            recaptcha.current.reset();
             setUser(v => ({
                ...v,
                loading: false,
                error: 'Capcha no valido'
            }));
        }
    }

    function onRecaptcha(value) {
      
        setUser(v => ({
            ...v,
            captcha: value,
        }));
    }

    function onClean(value) {
     
        setUser(v => ({
            ...v,
            captcha: '',
        }));
    }

    return (
        User.show === false ?
            <Loading/>
            :
            <form className='Session' onSubmit={Iniciar} >
                <Tabla>
                    <Head>
                        <Row>
                            <Cell colSpan={2}><img src={Logo} alt="Logo KMP" /></Cell>
                        </Row>
                        <Row>
                            <Cell colSpan={2}>Inicias Sesion</Cell>
                        </Row>
                    </Head>
                    <Body>
                        <Row>
                            <Cell>Usuario</Cell>
                            <Cell><input type='text' disabled={User.loading} placeholder='Usuario' defaultValue={User.mail} required onChange={(e) => setUser({
                                ...User,
                                mail: e.target.value
                            })} /></Cell>
                        </Row>
                        <Row>
                            <Cell>Contraseña</Cell>
                            <Cell><input disabled={User.loading} type='password' defaultValue={User.pass} placeholder='Contraseña' required onChange={(e) => setUser({
                                ...User,
                                pass: e.target.value
                            })} /></Cell>
                        </Row>
                        <Row>
                            <Cell>Mantener sesion</Cell>
                            <Cell><input disabled={User.loading} type='checkbox' onClick={(e) => {
                                setUser({
                                    ...User,
                                    check: e.target.checked
                                })
                            }} /></Cell>
                        </Row>
                        <Row>
                            <Cell className="ses" colSpan={2}>
                                <ReCAPTCHA ref={recaptcha} sitekey="6LcuH9IsAAAAAIQi1E8Js6eQkdnaCfHFE80TzNmf" onChange={onRecaptcha} onExpired={onClean} onErrored={onClean}/>
                            </Cell>
                        </Row>
                        <Row>
                            <Cell className="ses" colSpan={2}><button disabled={User.loading} type="submit">Iniciar Sesión</button></Cell>
                        </Row>
                        {
                            User.error === '' ?
                                ''
                                :
                                <Row>
                                    <Cell className="ses" colSpan={2}><span>{User.error}</span></Cell>
                                </Row>
                        }
                    </Body>
                </Tabla>
            </form>
    )
}
